var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "GRC"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.totalrejectedcount()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "card-header ",
    staticStyle: {
      "height": "40px",
      "margin-bottom": "4px",
      "padding": "0 10px",
      "background-color": "#f3faf9"
    }
  }, [_c('h6', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('grcList.grcCorrection')))])]), _vm._v(" "), _c('b-card', {
    attrs: {
      "size": "modal-lg"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.table.columns.dr')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGRCdata.DRNo),
      expression: "editGRCdata.DRNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num|min:5'),
      expression: "'required|alpha_num|min:5'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('editGRCdata.DRNo')
    },
    attrs: {
      "data-vv-scope": "editGRCForm",
      "type": "text",
      "placeholder": _vm.$t('removeHold.drNoPlaceHolder'),
      "name": "DRNo",
      "id": "DRNo",
      "data-vv-as": "DR number"
    },
    domProps: {
      "value": (_vm.editGRCdata.DRNo)
    },
    on: {
      "keyup": _vm.getClientId,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editGRCdata.DRNo = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.DRerrors) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.DRerrors))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading,
      "is-full-screen": false
    }
  }), _vm._v(" "), (_vm.isfound) ? _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "25px",
      "color": "green"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isnotfound) ? _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.merchantname) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.printData.merchant')) + "  "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(this.merchantname))])])]) : _vm._e()]), _vm._v(" "), (_vm.isfound) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.productID'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGRCdata.ProductID),
      expression: "editGRCdata.ProductID"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('editGRCdata.ProductID')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('printProductDetails.productIdPlaceHolder'),
      "name": "ProductID",
      "id": "ProductID",
      "data-vv-as": "Product ID",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.editGRCdata.ProductID)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.editGRCdata.ProductID = $event.target.value
      }, _vm.showSearchDR]
    }
  }), _vm._v(" "), (_vm.polineerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.polineerror))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.isProductidfound) ? _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "25px",
      "color": "green"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isProductidnotfound) ? _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isProductidfound && _vm.isfound) ? _c('div', {
    staticClass: "form-group row"
  }, [(this.linemrpData.length > 1) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.mrp')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]) : _vm._e(), _vm._v(" "), (this.linemrpData.length > 1) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGRCdata.mrp),
      expression: "editGRCdata.mrp"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mrp"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editGRCdata.mrp = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.showDetailsRecordsDR]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('grcList.SelectMrp')))]), _vm._v(" "), _vm._l((_vm.linemrpData), function(warehouse_obj) {
    return _c('option', {
      domProps: {
        "value": warehouse_obj.mrp
      }
    }, [_vm._v(_vm._s(warehouse_obj.mrp))])
  })], 2)]) : _vm._e(), _vm._v(" "), (this.linemrpData.length == 1) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.mrp')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]) : _vm._e(), _vm._v(" "), (this.linemrpData.length == 1) ? _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n                " + _vm._s(this.linemrpData[0].mrp) + "\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isProductidfound && _vm.isfound && _vm.ismrpfound) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.productName')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', [_vm._v(_vm._s(_vm.lineitemdata.productname))])])]) : _vm._e(), _vm._v(" "), (_vm.isProductidfound && _vm.isfound && _vm.ismrpfound) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('removeHold.poLineNumber')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', [_vm._v(_vm._s(_vm.lineitemdata.productlinenumber))])])]) : _vm._e(), _vm._v(" "), (_vm.isProductidfound && _vm.isfound && _vm.ismrpfound) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('grcList.totalPoLineQty')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', [_vm._v(_vm._s(this.editGRCdata.polineqty))])])]) : _vm._e(), _vm._v(" "), (_vm.isProductidfound && _vm.isfound && _vm.ismrpfound) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('removeHold.invoiceLineQty'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGRCdata.invoicelineqty),
      expression: "editGRCdata.invoicelineqty"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('editGRCdata.invoicelineqty')
    },
    attrs: {
      "data-vv-scope": "editGRCdata",
      "type": "text",
      "placeholder": _vm.$t('grcList.invoiceLineQuantityPlaceholder'),
      "name": "invoicelineqty",
      "id": "invoicelineqty",
      "data-vv-as": "Invoice Line Quantity"
    },
    domProps: {
      "value": (_vm.editGRCdata.invoicelineqty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editGRCdata.invoicelineqty = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('editGRCdata.invoicelineqty')),
      expression: "errors.has('editGRCdata.invoicelineqty')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcList.invoiceLineQuantityError')))])])]) : _vm._e(), _vm._v(" "), (_vm.isProductidfound && _vm.isfound && _vm.ismrpfound) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('removeHold.totalReceivedQty')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGRCdata.totalqty),
      expression: "editGRCdata.totalqty"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('editGRCdata.totalqty')
    },
    attrs: {
      "data-vv-scope": "editGRCdata",
      "type": "text",
      "placeholder": _vm.$t('supportRequest.totalQuantityPlaceHolder'),
      "name": "totalqty",
      "id": "totalqty",
      "data-vv-as": "Total Quantity"
    },
    domProps: {
      "value": (_vm.editGRCdata.totalqty)
    },
    on: {
      "keyup": _vm.checktotalqty,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editGRCdata.totalqty = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('editGRCdata.totalqty')),
      expression: "errors.has('editGRCdata.totalqty')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcList.acceptedQuantityError')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.putawaytotalqtyerror),
      expression: "putawaytotalqtyerror"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcList.putAwayQtyMessage')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cannotexceedQtyerror),
      expression: "cannotexceedQtyerror"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcList.reductionAllowedMessage')))])])]) : _vm._e(), _vm._v(" "), (_vm.isProductidfound && _vm.isfound && _vm.ismrpfound) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('grcList.acceptedQuantity')) + "\n                   "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGRCdata.acceptedqty),
      expression: "editGRCdata.acceptedqty"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('editGRCdata.acceptedqty')
    },
    attrs: {
      "data-vv-scope": "editGRCdata",
      "type": "text",
      "placeholder": _vm.$t('grcList.acceptedQuantityPlaceholder'),
      "name": "acceptedqty",
      "id": "acceptedqty",
      "data-vv-as": "Accepted quantity"
    },
    domProps: {
      "value": (_vm.editGRCdata.acceptedqty)
    },
    on: {
      "keyup": _vm.checkacceptedqty,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editGRCdata.acceptedqty = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('editGRCdata.acceptedqty')),
      expression: "errors.has('editGRCdata.acceptedqty')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcList.acceptedQuantityError')))]), _vm._v(" "), (_vm.acceptedqterrormsg != '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.acceptedqterrormsg))]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.putawayacceptedqtyerror),
      expression: "putawayacceptedqtyerror"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcList.putAwayQtyMessage')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cannotexccedacceptedqtyerror),
      expression: "cannotexccedacceptedqtyerror"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcList.reductionAllowedMessage')))])])]) : _vm._e(), _vm._v(" "), (_vm.isProductidfound && _vm.isfound && _vm.ismrpfound) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('grcRejectReport.RejectedQty')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGRCdata.rejectedqty),
      expression: "editGRCdata.rejectedqty"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('editGRCdata.rejectedqty')
    },
    attrs: {
      "data-vv-scope": "editGRCdata",
      "type": "text",
      "placeholder": _vm.$t('grcList.rejectedQuantityPlaceholder'),
      "name": "rejectedqty",
      "id": "rejectedqty",
      "data-vv-as": "Rejected quantity"
    },
    domProps: {
      "value": (_vm.editGRCdata.rejectedqty)
    },
    on: {
      "keyup": _vm.checkrejectedqty,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editGRCdata.rejectedqty = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('editGRCdata.rejectedqty')),
      expression: "errors.has('editGRCdata.rejectedqty')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('editGRCdata.rejectedqty')))]), _vm._v(" "), (_vm.rejectedqterrormsg != '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.rejectedqterrormsg))]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cannotexccedrejectedqtqtyerror),
      expression: "cannotexccedrejectedqtqtyerror"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcRejectReport.reductionAllowedMessage')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  })]) : _vm._e(), _vm._v(" "), (_vm.isProductidfound && _vm.isfound && _vm.ismrpfound) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('grcList.rejectedReason'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "height": "222px",
      "border-style": "ridge",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('cameraApp.rejectReason')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('grcRejectReport.RejectedQty')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('grcRejectReport.rejectedDate')))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listReasonData), function(select, index) {
    return (_vm.listReasonData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(select.reason))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (select.rejectedquantity),
        expression: "select.rejectedquantity"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (select.rejectedquantity)
      },
      on: {
        "keyup": function($event) {
          _vm.checkreasondata(select)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          select.rejectedquantity = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(select.rejecteddate))])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGRCdata.optinalreason),
      expression: "editGRCdata.optinalreason"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "client"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editGRCdata.optinalreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('grcList.selectReason')))]), _vm._v(" "), _vm._l((_vm.listReasonListData), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.reasonname
      }
    }, [_vm._v(_vm._s(client_obj.reasonname))])
  })], 2)]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGRCdata.rejectedoptionalqty),
      expression: "editGRCdata.rejectedoptionalqty"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.editGRCdata.rejectedoptionalqty)
    },
    on: {
      "keyup": function($event) {
        _vm.checkreasondata(_vm.editGRCdata.rejectedoptionalqty)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editGRCdata.rejectedoptionalqty = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td')])], 2)])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.arrayofqtyerror),
      expression: "arrayofqtyerror"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcList.rejectedQuantityMessage')))])]) : _vm._e(), _vm._v(" "), (_vm.totalrejectcounterrmsg != '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.totalrejectcounterrmsg))]) : _vm._e(), _vm._v(" "), (_vm.istotalquantitymatchederror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcList.totalReceivedQuantity')))]) : _vm._e(), _vm._v(" "), (_vm.isProductidfound && _vm.isfound && _vm.islotcontrol) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-card', [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "font-size": "12px !important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "width": "2%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.sr')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.lotNo')) + "."), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "width": "13%"
    }
  }, [_vm._v(_vm._s(_vm.$t('grcLotReport.acceptedLotQTY'))), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "data-v-60f0c85d": ""
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "width": "13%"
    }
  }, [_vm._v(_vm._s(_vm.$t('grcLotReport.rejectedLotQTY'))), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "data-v-60f0c85d": ""
    }
  }, [_vm._v("*")])]), _vm._v(" "), (_vm.islotcontrol) ? _c('th', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "width": "13%"
    }
  }, [_vm._v(_vm._s(_vm.$t('grcList.mfgDate')))]) : _vm._e(), _vm._v(" "), (_vm.islotcontrol) ? _c('th', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "width": "8%"
    }
  }, [_vm._v(_vm._s(_vm.$t('grcList.shelfLife')))]) : _vm._e(), _vm._v(" "), (_vm.islotcontrol) ? _c('th', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.expiryDate'))), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "data-v-60f0c85d": ""
    }
  }, [_vm._v("*")])]) : _vm._e(), _vm._v(" "), (_vm.islotcontrol) ? _c('th', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('client.action')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "10px"
    }
  })])]), _vm._v(" "), _vm._l((_vm.lotitems), function(lotitem, index) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "padding": "10px"
      },
      attrs: {
        "width": "2%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px"
      },
      attrs: {
        "width": "16%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lotitem.lotno),
        expression: "lotitem.lotno"
      }],
      staticClass: "lotno",
      class: (lotitem.lotnoerror == true) ? 'input-invalid' : '',
      staticStyle: {
        "height": "30px",
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "name": "Lotno",
        "id": "Lotno",
        "placeholder": _vm.$t('grcList.enterLotNo'),
        "ind": index,
        "autocomplete": "off",
        "disabled": lotitem.ismovedtorejected || lotitem.lotrackindone == 1
      },
      domProps: {
        "value": (lotitem.lotno)
      },
      on: {
        "change": function($event) {
          _vm.checklotno(index, lotitem.lotno)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          lotitem.lotno = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px"
      },
      attrs: {
        "width": "13%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lotitem.acceptedlotqty),
        expression: "lotitem.acceptedlotqty"
      }],
      class: (lotitem.singlelotputawayerror == true) ? 'input-invalid' : '',
      staticStyle: {
        "height": "30px",
        "width": "100%"
      },
      attrs: {
        "type": "number",
        "min": "0",
        "name": "acceptedlotqty",
        "id": "acceptedlotqty",
        "autocomplete": "off",
        "disabled": lotitem.ismovedtorejected
      },
      domProps: {
        "value": (lotitem.acceptedlotqty)
      },
      on: {
        "change": function($event) {
          _vm.checkacclotqty(index, lotitem.acceptedlotqty)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          lotitem.acceptedlotqty = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px"
      },
      attrs: {
        "width": "13%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lotitem.rejectedlotqty),
        expression: "lotitem.rejectedlotqty"
      }],
      staticClass: "rejectedlotqty",
      staticStyle: {
        "height": "30px",
        "width": "100%"
      },
      attrs: {
        "type": "number",
        "min": "0",
        "name": "rejectedlotqty",
        "id": "rejectedlotqty",
        "autocomplete": "off",
        "disabled": lotitem.ismovedtorejected
      },
      domProps: {
        "value": (lotitem.rejectedlotqty)
      },
      on: {
        "change": function($event) {
          _vm.checkrejectedlotqty(index, lotitem.rejectedlotqty)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          lotitem.rejectedlotqty = $event.target.value
        }
      }
    })]), _vm._v(" "), (_vm.islotcontrol) ? _c('td', {
      staticStyle: {
        "padding": "10px"
      },
      attrs: {
        "width": "8%"
      }
    }, [_c('b-form-input', {
      staticStyle: {
        "padding": "0px !important",
        "height": "30px"
      },
      attrs: {
        "width": "80%",
        "type": "date",
        "placeholder": _vm.$t('common.datePlaceholder'),
        "name": "lotmfgdate",
        "id": "lotmfgdate",
        "disabled": lotitem.ismovedtorejected || lotitem.lotrackindone == 1 || lotitem.isinvalidlot
      },
      on: {
        "change": function($event) {
          _vm.checkaccmfgdate(index, lotitem.lotmfgdate);
          _vm.shelflifeChanged(index)
        }
      },
      model: {
        value: (lotitem.lotmfgdate),
        callback: function($$v) {
          lotitem.lotmfgdate = $$v
        },
        expression: "lotitem.lotmfgdate"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.islotcontrol) ? _c('td', {
      staticStyle: {
        "padding": "10px"
      },
      attrs: {
        "width": "13%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lotitem.shelflife),
        expression: "lotitem.shelflife"
      }],
      staticClass: "shelflife",
      staticStyle: {
        "height": "30px",
        "width": "100%"
      },
      attrs: {
        "type": "number",
        "min": "0",
        "data-vv-as": "shelflife",
        "name": "shelflife",
        "index": index,
        "id": "shelflife",
        "autocomplete": "off",
        "disabled": lotitem.ismovedtorejected || lotitem.lotrackindone == 1 || lotitem.isinvalidlot
      },
      domProps: {
        "value": (lotitem.shelflife)
      },
      on: {
        "change": function($event) {
          _vm.shelflifeChanged(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          lotitem.shelflife = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.islotcontrol) ? _c('td', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('b-form-input', {
      staticClass: "exprirydate",
      staticStyle: {
        "padding": "0px !important",
        "height": "30px"
      },
      attrs: {
        "width": "80%",
        "type": "date",
        "placeholder": _vm.$t('common.datePlaceholder'),
        "data-vv-as": "exprirydate",
        "name": "exprirydate",
        "id": "exprirydate",
        "placeholder": "",
        "autocomplete": "off",
        "disabled": lotitem.ismovedtorejected || lotitem.lotrackindone == 1 || lotitem.isinvalidlot
      },
      on: {
        "input": function($event) {
          _vm.checkexpirydate(index)
        }
      },
      model: {
        value: (lotitem.lotexpirydate),
        callback: function($$v) {
          lotitem.lotexpirydate = $$v
        },
        expression: "lotitem.lotexpirydate"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.islotcontrol) ? _c('td', {
      staticStyle: {
        "padding": "5px"
      },
      attrs: {
        "width": "8%"
      }
    }, [(lotitem.ischeckbutton && lotitem.lotrackindone != 1 && !lotitem.isinvalidlot) ? _c('a', {
      staticClass: "glassbox",
      staticStyle: {
        "color": "white",
        "height": "auto",
        "text-align": "center",
        "width": "100px",
        "padding": "5px",
        "margin-top": "10px"
      },
      on: {
        "click": function($event) {
          _vm.checklot(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('grcList.shelflifeCheck')))]) : _vm._e(), _vm._v(" "), (lotitem.isshelflifenotmatched && lotitem.ismovedbutton && !lotitem.isinvalidlot) ? _c('a', {
      staticClass: "glassbox",
      staticStyle: {
        "color": "white",
        "height": "auto",
        "text-align": "center",
        "width": "80px",
        "padding-top": "5px",
        "margin-top": "10px"
      },
      on: {
        "click": function($event) {
          _vm.movetorejected(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('grcList.moveToRejected')))]) : _vm._e(), _vm._v(" "), (lotitem.isshelflifematched && !lotitem.isinvalidlot) ? _c('i', {
      staticClass: "fa fa-check",
      staticStyle: {
        "font-size": "25px",
        "color": "green"
      }
    }) : _vm._e(), _vm._v(" "), (lotitem.isshelflifenotmatched && lotitem.ismovedbutton && !lotitem.isinvalidlot) ? _c('i', {
      staticClass: "fa fa-close",
      staticStyle: {
        "font-size": "25px",
        "color": "red"
      }
    }) : _vm._e(), _vm._v(" "), (lotitem.isshelflifenotmatched && lotitem.ismovedbutton && !lotitem.isinvalidlot) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.$t('grcList.lotExpCriteriaErr')))]) : _vm._e(), _vm._v(" "), (lotitem.ismovedtorejected) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.$t('grcList.moveToRejected')))]) : _vm._e(), _vm._v(" "), (lotitem.isinvalidlot) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.$t('grcList.invalidLot')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px"
      }
    }, [(lotitem.lotrackindone != 1) ? _c('a', {
      staticClass: "glassbox",
      staticStyle: {
        "width": "auto !important",
        "color": "white",
        "height": "auto",
        "text-align": "center",
        "padding": "5px"
      },
      on: {
        "click": function($event) {
          _vm.clearsinglelot(index)
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('grcList.clear')) + " ")]) : _vm._e()])])])
  })], 2), _vm._v(" "), (_vm.acclotqtyerrormsg) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcList.acceptedQuantityMessage')))]) : _vm._e(), _vm._v(" "), (_vm.additemerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcList.fillEmptyRowMessage')))]) : _vm._e(), _vm._v(" "), (_vm.accmfgdateerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.accmfgdateerrormsg))]) : _vm._e(), _vm._v(" "), (_vm.rejlotqtyerrormsg) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcList.rejectedLotQuantityMessage')))]) : _vm._e(), _vm._v(" "), (_vm.lotputawayerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcList.putAwayQuantityMessage')))]) : _vm._e()]), _vm._v(" "), (!_vm.isqtymatched) ? _c('a', {
    staticClass: "glassbox",
    staticStyle: {
      "color": "white",
      "height": "30px",
      "text-align": "center",
      "width": "80px",
      "padding-top": "5px",
      "margin-top": "10px"
    },
    on: {
      "click": _vm.addqtyLot
    }
  }, [_vm._v(_vm._s(_vm.$t('grcList.addLot')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "GRCfooter form-actions"
  })])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.isProductidfound && _vm.isfound && _vm.ismrpfound) ? _c('div', {
    staticClass: "inwardfooter form-actions"
  }, [_c('b-button', {
    staticClass: "btn btn-danger glasssec  float-right",
    attrs: {
      "type": "text",
      "disabled": !_vm.isComplete1 && _vm.isLoading
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')) + "  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-primary glass float-right",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isComplete1
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')) + " ")])], 1) : _vm._e()])], 1)])])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4fabf5ed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fabf5ed","hasScoped":true}!./src/views/components/GRCcorrection/grccorrection.component.html
// module id = 1280
// module chunks = 0